import React from 'react';
import './Features.css';

/* helper for public/ assets */
const pub = (file) => `${process.env.PUBLIC_URL}/${file}`;

/* hard-coded tag data */
const TAGS = [
  { icon: 'icon_competitors.svg',  label: 'Competitors'   },
  { icon: 'icon_unit_economy.svg', label: 'Unit Economy'  },
  { icon: 'icon_market_size.svg',  label: 'Market Size'   },
  { icon: 'icon_action_plan.svg',  label: 'Action Plan'   },
];

export default function Features() {
  return (
    <section className="features">
      <div className="card">
        {/* headline */}
        <h2 className="features-hero">
          Write your ideas in simple words, we will structure
          <br />
          and polish it together
        </h2>

        <div className="separator" />

        {/* subtitle + scroll icon on the same row */}
        <div className="subtitle-wrap">
          <p className="subtitle">
            Do not spend extra two weeks surfing the internet and combining
            <br />
            excel sheets, figure out if it is worth going deep in a day.
          </p>

          <img
            className="scroll-icon"
            src={pub('icon_scroll_up.svg')}
            alt=""
            width="58"
            height="58"
          />
        </div>

        {/* tag row */}
        <div className="tags">
          {TAGS.map(({ icon, label }) => (
            <span key={label} className="tag">
              <img
                className="tag-icon"
                src={pub(icon)}
                alt=""
                width="28"
                height="28"
              />
              {label}
              <span className="tag-status">✕</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
